import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import Postpal_Logo from "../../assets/images/home.png";
import jsPDF from "jspdf";
import { toast } from "react-toastify";

export const generateMeasurementPdf = async (itemId) => {
  try {
    let mesurementData = {};
    const formDataRef = doc(db, "forms", itemId);
    const docSnap = await getDoc(formDataRef);
    if (docSnap.exists()) {
        mesurementData = docSnap.data()?.MeasurementForm;
    }
    const document = new jsPDF();
    const pageWidth = document.internal.pageSize.getWidth(); // Get the page width

    // Add the logo image centered at the top
    const logoWidth = (48 * 25.4) / 96;
    const logoHeight = (48 * 25.4) / 96;
    const logoXPosition = (pageWidth - logoWidth) / 2;
    const logoYPosition = 20;

    document.addImage(
      Postpal_Logo,
      "PNG",
      logoXPosition,
      logoYPosition,
      logoWidth,
      logoHeight
    );

    // Set font size for the title
    document.setFontSize(18);

    // Center the title manually by calculating half the page width and offset for the string
    const title = "POSTPAL Measurement Report";
    document.text(title, pageWidth / 2, logoYPosition + logoHeight + 10, {
      align: "center",
    });

    // Set font size for the rest of the document
    document.setFontSize(12);

    const tHeader = [
      [{ content: "Item Name" }, { content: mesurementData?.productname }],
      [{ content: "Package ID" }, { content: mesurementData?.ordernumber }],
      [{ content: "Item ID" }, { content: mesurementData?.productid }],
      [{ content: "Store Name" }, { content: mesurementData?.storename }],
    ];

    document.autoTable({
      startY: logoYPosition + logoHeight + 10 + 10,
      margin: 40,
      body: tHeader,
      theme: "grid",
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        lineWidth: 0.3,
        fontStyle: "bold",
      },
      bodyStyles: {
        fontStyle: "bold",
      },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 50 },
      },
    });

    const tBody = [
      [
        {
          content:
            "In your view, is the package description the same as the item inside the box?",
        },
        {
          content: mesurementData?.measurementPackage === true ? "Yes" : "No",
        },
      ],
      [
        { content: "Serial number on box" },
        { content: mesurementData?.serialnumberBox },
      ],
      [
        { content: "Serial number from on the product" },
        {
          content: mesurementData?.serialnumberProduct,
        },
      ],
      [
        { content: "Serial number from on software information page" },
        {
          content: mesurementData?.serialnumberInformation,
        },
      ],
      [
        {
          content: "Cloth general measurement",
        },
        {
          content: `Length: ${mesurementData?.clothMeasurement?.length}\nWidth: ${mesurementData?.clothMeasurement?.width}\nHeight: ${mesurementData?.clothMeasurement?.height}`,
        },
      ],
      [
        {
          content: "Neck area measurement",
        },
        {
          content: `Length: ${mesurementData?.neckAreaMeasurement?.length}\nWidth: ${mesurementData?.neckAreaMeasurement?.width}`,
        },
      ],
      [
        {
          content: "Hand area measurement",
        },
        {
          content: `Length: ${mesurementData?.handAreaMeasurement?.length}\nWidth: ${mesurementData?.handAreaMeasurement?.width}`,
        },
      ],
      [
        {
          content: "Waist area measurement",
        },
        {
          content: `Length: ${mesurementData?.waistAreaMeasurement?.length}\nWidth: ${mesurementData?.waistAreaMeasurement?.width}`,
        },
      ],
      [
        {
          content: "Leg length",
        },
        {
          content: `Length: ${mesurementData?.legLength?.length}\nWidth: ${mesurementData?.legLength?.width}`,
        },
      ],
      [
        {
          content: "Circumference measurement",
        },
        {
          content: `Deameter: ${mesurementData?.capCircumferenceMeasurement?.deameter}\nRadius : ${mesurementData?.capCircumferenceMeasurement?.radius}`,
        },
      ],
      [
        {
          content: "What is the mentioned shoe size on the box?",
        },
        {
          content: mesurementData?.shoesAllSize?.boxsize,
        },
      ],
      [
        {
          content: "What is the mentioned shoe size inside the shoe?",
        },
        {
          content: mesurementData?.shoesAllSize?.embossedsize,
        },
      ],
      [
        {
          content: "What is the length from front to back (Inside)",
        },
        {
          content: mesurementData?.shoesAllSize?.inside,
        },
      ],
      [
        {
          content: "What is the length from front to back (Outside)",
        },
        {
          content: mesurementData?.shoesAllSize?.outside,
        },
      ],
      [
        {
          content: "Are both sides the same size?",
        },
        {
          content:
            mesurementData?.shoesAllSize?.samesize === false ? "No" : "Yes",
        },
      ],
      [
        {
          content: "What is the measure of the product or item?",
        },
        {
          content: `Length: ${mesurementData?.allOtherProducts?.length}\nWidth: ${mesurementData?.allOtherProducts?.width}\nHeight: ${mesurementData?.allOtherProducts?.height}`,
        },
      ],
      [
        {
          content: "Weight measurement",
        },
        {
          content: mesurementData?.weightMeasurements,
        },
      ],
    ];

    document.autoTable({
      startY: document.previousAutoTable.finalY + 10,
      margin: 40,
      head: [["Question", "Details"]],
      body: tBody,
      theme: "grid",
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: ["#5E17EB"],
        textColor: ["#ffffff"],
        lineWidth: 0.3,
      },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 50 },
      },
      didParseCell: function (data) {
        if (data.section === "body" && data.column.index === 0) {
          // Set font style to bold for the first cell in each row
          data.cell.styles.fontStyle = "bold";
        }
        // if (data.row.index === 18) {
        //   // Adjust row height if it's the one with images
        //   data.row.height = 20;
        // }
      },
    });

    const tFooter = [
      [
        { content: "comments and feedback" },
        {
          content: mesurementData?.commentFeedback,
        },
      ],
      [
        { content: "Report is prepared onbehalf of" },
        { content: mesurementData?.userName },
      ],
      [
        { content: "Report is completed by" },
        { content: mesurementData?.adminName },
      ],
      [
        {
          content: "Inspection report number",
        },
        {
          content: mesurementData?.inspectionReport,
        },
      ],
    ];

    document.autoTable({
      startY: document.previousAutoTable.finalY + 10,
      margin: 40,
      body: tFooter,
      theme: "grid",
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        lineWidth: 0.3,
        // fontStyle: "bold",
      },
      // bodyStyles: {
      //   fontStyle: "bold",
      // },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 50 },
      },
      didParseCell: function (data) {
        if (data.section === "body" && data.column.index === 0) {
          // Set font style to bold for the first cell in each row
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    const getImageType = (url) => {
      const extension = url.split(".").pop().split("?")[0];
      if (extension === "png") return "PNG";
      if (extension === "jpg" || extension === "jpeg") return "JPEG";
      if (extension === "gif") return "GIF";

      return "PNG";
    };

    const fetchImageAsBase64 = async (url) => {
      const response = await fetch(url);
      if (response.status === 200) {
        const blob = await response.blob();
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
    };

    const prepareImages = async () => {
      const imageUrls = mesurementData?.measurementUploadImg || [];

      const images = await Promise.all(
        imageUrls.map((url) => fetchImageAsBase64(url))
      );
      return images;
    };

    const base64Images = await prepareImages();

    // Add each image on a separate page
    base64Images.forEach((image, index) => {
      if (image) {
        document.addPage();
        const imageWidth = 50; // Fixed width for images
        const imageHeight = 50; // Fixed height for images
        const xPosition = (document.internal.pageSize.getWidth() - imageWidth) / 2;
        const yPosition = 20; // Margin from the top

        // Add title for the image page
        document.setFontSize(16);
        document.text("Uploaded Images", document.internal.pageSize.getWidth() / 2, 10, {
          align: "center",
        });

        document.addImage(
          image,
          getImageType(mesurementData?.measurementUploadImg[index]),
          xPosition,
          yPosition,
          imageWidth,
          imageHeight
        );
      }
    });

    const blob = document.output("blob");
    const url = URL.createObjectURL(blob);
    await updateDoc(formDataRef, {
        MeasurementForm: {
        ...mesurementData,
        isDocGenerated: true,
        docUrl: url,
      },
    }).then(() => {
      toast.success("Document Generated Successfully");
    });
  } catch (error) {
    console.error("Failed to generate PDF", error);
  }
};
